export const SEARCH_FONT_SIZE_DEFAULT = 18;
